import { render, staticRenderFns } from "./Associate.vue?vue&type=template&id=2e8f4b44&lang=pug&"
import script from "./Associate.vue?vue&type=script&lang=js&"
export * from "./Associate.vue?vue&type=script&lang=js&"
import style0 from "./Associate.vue?vue&type=style&index=0&id=2e8f4b44&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports